import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { MaterialTypeForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditMaterialType({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const materialType = useSelector((state) => state.materialType);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: materialType.name,
      description: materialType.description,
    },
  });

  useEffect(() => {
    dispatch(actions.materialTypeGet(id));
    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      console.log(data);
      await dispatch(actions.materialTypePut(id, data));
      alert('สำเร็จ');
      await dispatch(actions.materialTypeGet(id));
    } catch (error) {
      console.log(error);
    }
  };
  if (materialType.isLoading || materialType.rows) {
    return <Loading />;
  }
  if (!materialType.isLoading && materialType.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <MaterialTypeForm
                errors={errors}
                materialType={materialType}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditMaterialType.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditMaterialType.defaultProps = {
  title: '',
  subtitle: '',
};
